<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  @if (tooltip) {
    <title>{{ tooltip }}</title>
  }
  <path d="M3,3H21V5H3V3M3,7H15V9H3V7M3,11H21V13H3V11M3,15H15V17H3V15M3,19H21V21H3V19Z"/>
</svg>
